export default __webpack_public_path__ + "static/media/artwork-card-7.954098ca.png";